import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { AutoComplete, Input, Button, Col, Form, Row, Select, Space, Typography } from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useContext, useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { SUCCESS_CODE } from "../../../../lib/const";
import { routes } from "../../../../routes";
import {
  SearchCompetitorContext,
  initialPageValues,
  initialSearchValues
} from "../searchContext";
import useCountryCompetitor from "../../../../lib/hooks/useCountryCompetitor";

const { Title } = Typography;
const { Option } = Select;

const Search = ({ roleUser }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [,,sortCountries] = useCountryCompetitor();

  const {
    setPageValues,
    setSearch,
    searchValues,
    pageValues,
    setSearchValues
  } = useContext(SearchCompetitorContext);
  const [searchCollapse, setSearchCollapse] = useState(false);
  const [countryId, setCountryId] = useState("");

  const handleClearSearchForm = () => {
    form.resetFields();
    setCountryId("");
    setSearchValues(initialSearchValues);
    setPageValues(initialPageValues);
    setSearch(true);
  };

  const onSearch = (values) => {
    setSearch(true);
    setSearchValues({
      countryId: values?.countryId || ""
    });
  };

  const onChange = (value) => {
    if (value === "") {
      form.resetFields();
    }
  }

  useEffect(() => {}, [form]);

  return (
    <Content>
      <Form style={{ marginBottom: 20 }}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <div className="flex justify-between items-center">
              <Title level={4} style={{ marginTop: 15, color: "#6442A4" }}>
                คลังข้อมูลคู่แข่ง
              </Title>
              <div>
                <Space>
                  {(roleUser[0]?.isAll || roleUser[0]?.isCreate) && (
                    <Button
                      type="primary"
                      onClick={() => navigate(routes.add_customer_competitor)}
                    >
                      <PlusOutlined /> เพิ่มข้อมูล
                    </Button>
                  )}
                </Space>
              </div>
            </div>
          </Col>
        </Row>
      </Form>
      <Form
        layout={"vertical"}
        form={form}
        style={{
          padding: 20,
          backgroundColor: "#fff",
          borderRadius: "12px",
          border: "1px solid #F2F2F2",
          boxShadow: `0px 1px 10px 0px rgba(226, 216, 246, 0.40)`
        }}
        onFinish={(value) =>
          onSearch({
            ...value
          })
        }
      >
        <Row gutter={[24, 16]}>
          <Col className="gutter-row" span={12}>
            <Form.Item label="" name={"countryId"}>
              <Select
                allowClear
                showSearch
                optionFilterProp="label"
                placeholder="สัญชาติลูกค้า (ประเทศ)"
                style={{
                  width: "100%",
                }}
                maxTagCount={"responsive"}
                options={sortCountries}
                onSearch={onChange}
              />
              {/* <AutoComplete
                optionFilterProp="label"
                filterOption={true}
                options={sortCountries}
                onSelect={onSelectCustomerRegion}
              >
                <Input 
                  placeholder="สัญชาติลูกค้า (ประเทศ)"
                  prefix={<SearchOutlined />} 
                />
              </AutoComplete> */}
              {/* <Select
                allowClear
                style={{
                  width: "100%",
                }}
                placeholder="สัญชาติลูกค้า (ประเทศ)"
              >
                {countries.map((item) => (
                  <Option key={item.countryId} value={item.countryId}>
                    {item.countryNameTh}
                  </Option>
                ))}
              </Select> */}
            </Form.Item>
          </Col>

          <Col span={24} align="right">
            <Space>
              <Button onClick={handleClearSearchForm}>ล้างข้อมูล</Button>
              <Button type="primary" htmlType="submit">
                ค้นหา
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Content>
  );
};

export default Search;
